import { Package, MessageSquare, BarChart3, FileText, Link, Users } from "lucide-react";
import {
  Sidebar,
  SidebarContent,
  SidebarGroup,
  SidebarGroupContent,
  SidebarHeader,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
} from "@/components/ui/sidebar";

interface AppSidebarProps {
  currentPage: string;
  setCurrentPage: (page: string) => void;
}

// Base items everyone in the workspace sees. "Team" is appended below so the
// label is pulled in only when present.
const baseItems = [
  { title: "Feedback", id: "feedback", icon: MessageSquare },
  { title: "Insights", id: "insights", icon: BarChart3 },
  { title: "Custom Forms", id: "custom-forms", icon: FileText },
  { title: "Products", id: "products", icon: Package },
  { title: "Integration", id: "integration", icon: Link },
  { title: "Team", id: "team", icon: Users },
];

export function AppSidebar({ currentPage, setCurrentPage }: AppSidebarProps) {
  return (
    <Sidebar>
      <SidebarHeader className="px-4 py-4">
        <div className="flex items-center gap-2">
          <img src="/logo.png" alt="senloop" className="w-8 h-8 rounded-lg" />
          <span className="font-brand text-2xl font-extrabold tracking-tight text-foreground">
            senloop
          </span>
        </div>
      </SidebarHeader>
      <SidebarContent>
        <SidebarGroup>
          <SidebarGroupContent>
            <SidebarMenu>
              {baseItems.map((item) => (
                <SidebarMenuItem key={item.title}>
                  <SidebarMenuButton
                    onClick={() => setCurrentPage(item.id)}
                    isActive={currentPage === item.id}
                    className="cursor-pointer"
                  >
                    <item.icon />
                    <span>{item.title}</span>
                  </SidebarMenuButton>
                </SidebarMenuItem>
              ))}
            </SidebarMenu>
          </SidebarGroupContent>
        </SidebarGroup>
      </SidebarContent>
    </Sidebar>
  );
}
